import { render, staticRenderFns } from "./officialNotice.vue?vue&type=template&id=e91be416&"
import script from "./officialNotice.vue?vue&type=script&lang=js&"
export * from "./officialNotice.vue?vue&type=script&lang=js&"
import style0 from "./officialNotice.vue?vue&type=style&index=0&id=e91be416&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports